/* global axios */
import ApiClient from './ApiClient';

class InboxMembers extends ApiClient {
  constructor() {
    super('inbox_members', { accountScoped: true });
  }

  update({ inboxId, agentIds }) {
    const payload = {
      inbox_id: inboxId,
      agent_ids: agentIds,
    };

    return axios.patch(this.url, payload);
  }
}

export default new InboxMembers();